import { render } from "./datoAggiuntivo.vue?vue&type=template&id=2b4b64a9&ts=true"
import script from "./datoAggiuntivo.vue?vue&type=script&lang=ts"
export * from "./datoAggiuntivo.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__